module.exports = __webpack_public_path__ + "media/images/Tealight-no-wick-ab4b9046ddaa4950b28da6ad37e303d1.png";